export function observeAttributes(
  elem,
  callback = () => {
    /** default */
  }
) {
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        callback(mutation.attributeName, elem.getAttribute(mutation.attributeName), mutation.oldValue);
      }
    }
  });
  observer.observe(elem, {
    attributes: true,
    childList: false,
    subtree: false,
    attributeOldValue: true,
  });
  return () => observer.disconnect();
}
